<template>
  <div class="business-teams-page">
    <hero />

    <devices />

    <how-it-works />

    <get-started i18n-key="teams" />

    <companies-logos />

    <reviews i18n-key="b2c" />

    <faq id="faq" :type="'b2b'" />
  </div>
</template>

<script>
import Faq from "@/features/expendable-faq/expendable-faq"
import Hero from "@/pages/business/components/teams-hero"
import Devices from "@/pages/business/components/devices"
import HowItWorks from "@/pages/business/components/how-it-works"
import CompaniesLogos from "@/pages/business/components/companies-logos"
import GetStarted from "@/pages/business/components/get-started"
import Reviews from "@/pages/business/components/reviews"

export default {
  name: "BusinessTeamsPage",
  components: {
    Hero,
    Devices,
    Faq,
    HowItWorks,
    CompaniesLogos,
    GetStarted,
    Reviews
  }
}
</script>
